/* SillyFish — cart bridge
 *
 * 1. Add to bag  : one request (/cart/add.js), an optimistic count bump and a
 *                  fly-to-bag animation. The drawer does NOT open.
 * 2. Bag links   : re-render the drawer section, then open it.
 *
 * The AW26 PDP posts its form natively, which Shopify answers with a redirect
 * to /cart. Everything below exists to intercept that.
 */
(function () {
  var SECTION = 'cart-drawer-section';
  var busy = false;
  var stale = false;

  function drawerEl() { return document.getElementById('cart-drawer'); }

  function onCartPage() {
    var main = document.getElementById('MainContent');
    return !!(main && main.dataset && main.dataset.template === 'cart');
  }

  function bagLinks() {
    return document.querySelectorAll('.sfx-util a[href="/cart"], .sfx-util a[href^="/cart?"]');
  }

  function setCount(n) {
    var links = bagLinks();
    for (var i = 0; i < links.length; i++) {
      links[i].textContent = 'Bag (' + n + ')';
      links[i].classList.remove('sf-bag--bump');
      void links[i].offsetWidth;
      links[i].classList.add('sf-bag--bump');
    }
  }

  function currentCount() {
    var a = bagLinks()[0];
    if (!a) return 0;
    var m = (a.textContent || '').match(/(\d+)/);
    return m ? Number(m[1]) : 0;
  }

  function reconcileCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var links = bagLinks();
        for (var i = 0; i < links.length; i++) links[i].textContent = 'Bag (' + cart.item_count + ')';
      })
      .catch(function () {});
  }

  /* ---------- fly to bag ---------- */

  function injectStyles() {
    if (document.getElementById('sf-fly-styles')) return;
    var css = document.createElement('style');
    css.id = 'sf-fly-styles';
    css.textContent =
      '.sf-fly{position:fixed;z-index:2147483000;pointer-events:none;border-radius:2px;' +
      'object-fit:cover;box-shadow:0 8px 28px rgba(33,31,28,.18);will-change:transform,opacity}' +
      '.sf-bag--bump{animation:sf-bag-bump .42s cubic-bezier(.2,.9,.3,1)}' +
      '@keyframes sf-bag-bump{0%{transform:scale(1)}38%{transform:scale(1.14)}100%{transform:scale(1)}}' +
      '@media (prefers-reduced-motion: reduce){.sf-fly{display:none}.sf-bag--bump{animation:none}}';
    document.head.appendChild(css);
  }

  function flyToBag(sourceImg) {
    var target = bagLinks()[0];
    if (!sourceImg || !target || !sourceImg.getBoundingClientRect) return Promise.resolve();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return Promise.resolve();

    injectStyles();

    var from = sourceImg.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return Promise.resolve();

    var ghost = document.createElement('img');
    ghost.src = sourceImg.currentSrc || sourceImg.src;
    ghost.className = 'sf-fly';
    ghost.setAttribute('aria-hidden', 'true');

    var size = Math.min(from.width, from.height, 190);
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    ghost.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    ghost.style.top = (from.top + from.height / 2 - size / 2) + 'px';
    document.body.appendChild(ghost);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    var anim = ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 0.95 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.42 - 70) + 'px) scale(.52)', opacity: 0.85, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0 }
      ],
      { duration: 680, easing: 'cubic-bezier(.45,.05,.3,1)', fill: 'forwards' }
    );

    return anim.finished.catch(function () {}).then(function () { ghost.remove(); });
  }

  function heroImage(form) {
    var stage = document.querySelector('.sfx-gv.sfx-on img') ||
                document.querySelector('.sfx-stage img') ||
                (form ? form.querySelector('img') : null) ||
                document.querySelector('.sfx-galwrap img');
    return stage;
  }

  /* ---------- 1. Bag links open the drawer ---------- */

  function refreshDrawer() {
    var host = document.getElementById('shopify-section-' + SECTION);
    if (!host) return Promise.resolve();
    return fetch('/?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[SECTION];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = String(html).trim();
        var next = tmp.firstElementChild;
        if (next && host.parentNode) host.parentNode.replaceChild(next, host);
        stale = false;
      })
      .catch(function () {});
  }

  function openDrawer() {
    var work = stale || !drawerEl() ? refreshDrawer() : Promise.resolve();
    return work.then(function () {
      var d = drawerEl();
      if (d && typeof d.open === 'function') { d.open(); return true; }
      window.location.href = '/cart';
      return false;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/^\/cart\/?($|\?)/.test(href)) return;
    if (onCartPage() || !drawerEl()) return;
    e.preventDefault();
    openDrawer();
  });

  /* ---------- 2. AW26 PDP add to bag ---------- */

  var form = document.getElementById('sfx-form');
  if (!form) return;

  var btn = document.getElementById('sfx-add');
  var sticky = document.getElementById('sfx-sbtn');
  var stock = document.getElementById('sfx-stk');

  function variantId() {
    var field = form.querySelector('#sfx-varid') || form.querySelector('[name="id"]');
    return field && field.value ? field.value : '';
  }

  function setLabel(t) {
    if (btn) btn.textContent = t;
    if (sticky) sticky.textContent = t;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;

    var id = variantId();
    if (!id) {
      if (stock) stock.innerHTML = '<b>Choose a size first.</b>';
      var szs = form.querySelector('.sfx-szs');
      if (szs && szs.scrollIntoView) szs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    busy = true;
    var restore = (btn && btn.dataset.ready) || 'Add to bag';
    var img = heroImage(form);

    /* Animate immediately — do not wait on the network. */
    flyToBag(img);
    setCount(currentCount() + 1);
    setLabel('Added');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body && body.description ? body.description : 'Could not add to bag.');
          return body;
        });
      })
      .then(function () {
        stale = true;
        reconcileCount();
        setTimeout(function () { setLabel(restore); busy = false; }, 1100);
      })
      .catch(function (err) {
        setCount(Math.max(0, currentCount() - 1));
        setLabel(restore);
        busy = false;
        if (stock) stock.innerHTML = '<b>' + (err && err.message ? err.message : 'Could not add to bag.') + '</b>';
      });
  });

  if (sticky) {
    sticky.addEventListener('click', function (e) {
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }
})();